
import { defineComponent } from "vue";
import { mapActions, mapState } from "vuex";

export default defineComponent({
  name: "PorqueNosotros",
  computed: {
    ...mapState([]),
  },
  methods: {
    ...mapActions([]),
  },
});
